import { render, staticRenderFns } from "./ImageAndVideo.vue?vue&type=template&id=91635cb6&scoped=true"
import script from "./ImageAndVideo.vue?vue&type=script&lang=js"
export * from "./ImageAndVideo.vue?vue&type=script&lang=js"
import style0 from "./ImageAndVideo.vue?vue&type=style&index=0&id=91635cb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91635cb6",
  null
  
)

export default component.exports